<mat-card class="forgot-form">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <mat-card-header>
    <h1>TASTI-GRID</h1>
  </mat-card-header>

  <mat-card-subtitle>
    <p>Use your account email to receive password reset instructions.</p>
  </mat-card-subtitle>

  <mat-card-content>

    <form [formGroup]="passwordRequestGroup">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="text" placeholder="Email" formControlName="email" required/>
        <mat-error>
          @if (passwordRequestGroup.get('email')?.hasError('required')) {
            <span>
              An email is required.
            </span>
          }
        </mat-error>
      </mat-form-field>

      <button class="wide"
        mat-flat-button
        color="primary"
      [disabled]="passwordRequestGroup.invalid" (click)="requestPassword()">Request Password</button>
    </form>
  </mat-card-content>

</mat-card>
